import { useContext, useEffect, useState } from 'react';
import { Tabs } from '@general';
import { NotificationType } from '@types';

import { NotificationsContext } from '@/context';
import { NotificationListItem } from '../notificationListItem/NotificationListItem';

import styles from './notificationList.module.scss';

interface NotificationListProps {
	notifications: NotificationType[];
	onItemClick: (notification: NotificationType) => void;
}

export const NotificationList = ({ notifications, onItemClick }: NotificationListProps) => {
	// Context
	const { selectedNotification, setSelectedNotification } = useContext(NotificationsContext);
	// State
	const [ALL, UNREAD] = ['All', 'Unread'];
	const [toggle, setToggle] = useState(ALL);
	const [tabNotifications, setTabNotifications] = useState(notifications);

	useEffect(() => {
		if (toggle === UNREAD) {
			setTabNotifications(notifications.filter(msg => !msg.read));
		} else {
			setTabNotifications(notifications);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggle, UNREAD]); // important: not add notifications dependency

	useEffect(() => {
		setSelectedNotification(tabNotifications?.length ? tabNotifications[0] : undefined);
	}, [tabNotifications, setSelectedNotification]);

	const handleToggleClick = (value: string) => {
		setToggle(value);
	};

	return (
		<div className={styles.wrapper} data-testid="notificationsList">
			<div className={styles.toggle} aria-label="toggle between all and unread notifications">
				<Tabs tabs={[ALL, UNREAD]} handleClick={handleToggleClick} selectedTab={toggle} />
			</div>
			<div className={styles[`notification-list`]}>
				{tabNotifications.length ? (
					tabNotifications.map((item, ind) => (
						<NotificationListItem
							key={ind}
							notification={item}
							onItemClick={onItemClick}
							selected={selectedNotification?.id === item.id}
						/>
					))
				) : (
					<p className={styles.empty}>No new notifications are available.</p>
				)}
			</div>
		</div>
	);
};
